<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { getTradeBasis, getAliasBasisData} from '@/api/user'

/**
 * Starter component
 */
export default {
  page: {
    title: "交易成本",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "交易成本",

      profit_totalRows: 1,
      profit_currentPage: 1,
      profit_perPage: 10,
      profit_pageOptions: [10, 25, 50, 100],
      profit_filter: "",
      profit_filterOn: [],
      profit_sortBy: "-date",
      profit_sortDesc: false,
      profit_count: 0,
      profitData: [],
      profitfields: [
        {
          key: "date",
        },
        {
          key: "alias",
        },
        {
          key: "open_value",
        },
        {
          key: "open_basis",
        },
        {
          key: "close_value",
        },
        {
          key: "close_basis",
        },
        {
          key: "profit_value",
        },
        {
          key: "profit_basis",
        },
      ],

      basis_totalRows: 1,
      basis_currentPage: 1,
      basis_perPage: 10,
      basis_pageOptions: [10, 25, 50, 100],
      basis_filter: "",
      basis_filterOn: [],
      basis_sortBy: "-strategy_start",
      basis_sortDesc: false,
      basis_count: 0,
      basis_model: 1,
      tradefields: [
        {
          key: "name",
          sortable: true
        },
        {
          key: "alias",
          sortable: true
        },
        {
          key: "strategy_start",
          sortable: true
        },
        {
          key: "strategy_end",
          sortable: true
        },
        {
          key: "trade_start",
          sortable: true
        },
        {
          key: "trade_end",
          sortable: true
        },
        {
          key: "cost_time(m)",
          sortable: true
        },
        {
          key: "coin",
          sortable: true
        },
        {
          key: "long",
          sortable: true
        },
        {
          key: "short",
          sortable: true
        },
        {
          key: "amount",
          sortable: true
        },
        {
          key: "long_amount",
          sortable: true
        },
        {
          key: "short_amount",
          sortable: true
        },
        {
          key: "basis",
          sortable: true
        },
        {
          key: "realized_basis",
          sortable: true
        },
        {
          key: "long_price",
          sortable: true
        },
        {
          key: "short_price",
          sortable: true
        },
      ],
      tradedata: [],
    };
  },
  mounted() {
  },
  methods: {
    DataOnFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.basis_totalRows = filteredItems.length;
      this.basis_currentPage = 1;
    },
    basis_data() {
      let promise = getTradeBasis(this.basis_filter, this.basis_perPage, this.basis_currentPage-1); return promise.then(res => {
        this.basis_count = res["count"]
        // this.basis_currentPage = res["offset"] + 1
        console.log(this.basis_currentPage)
        return res["data"]
      }).catch(error => {
        console.log(error)
      })
    },
    profitOnFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.profit_totalRows = filteredItems.length;
      this.profit_currentPage = 1;
    },
    profit_data() {
      let promise = getAliasBasisData(this.profit_filter, this.profit_perPage, this.profit_currentPage-1); return promise.then(res => {
        this.profit_count = res["count"]
        // this.trade_currentPage = res["offset"] + 1
        console.log(this.profit_currentPage)
        return res["data"]
      }).catch(error => {
        console.log(error)
      })
    },
  }
};
</script>
<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              基差
            </h4>
            <b-tabs
              content-class="mt-3"
              nav-class="nav-tabs-custom"
            >
              <b-tab
                title="All"
                active
              >
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_length"
                      class="dataTables_length"
                    >
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="basis_perPage"
                          size="sm"
                          :options="basis_pageOptions"
                        />&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="basis_filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ml-2"
                        />
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive table-hover mb-0">
                  <b-table ref="basis_table"
                    :items="basis_data"
                    :fields="tradefields"
                    responsive="sm"
                    :per-page="basis_perPage"
                    :current-page="basis_currentPage"
                    :sort-by.sync="basis_sortBy"
                    :sort-desc.sync="basis_sortDesc"
                    :filter="basis_filter"
                    :filter-included-fields="basis_filterOn"
                  />
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="basis_currentPage"
                          :total-rows="basis_count"
                          :per-page="basis_perPage"
                          first-number
                          last-number
                        />
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
              <!-- <b-tab title="Buy" disabled> </b-tab>
                        <b-tab title="Sell" disabled> </b-tab> -->
            </b-tabs>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              基差汇总
            </h4>
            <b-tabs
              content-class="mt-3"
              nav-class="nav-tabs-custom"
            >
              <b-tab
                title="All"
                active
              >
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_length"
                      class="dataTables_length"
                    >
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="profit_perPage"
                          size="sm"
                          :options="profit_pageOptions"
                        />&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label  class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="profit_filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ml-2"
                        />
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive table-hover mb-0">
                  <b-table
                    :items="profit_data"
                    :fields="profitfields"
                    responsive="sm"
                    :per-page="profit_perPage"
                    :current-page="profit_currentPage"
                    :sort-by.sync="profit_sortBy"
                    :sort-desc.sync="profit_sortDesc"
                    :filter="profit_filter"
                    :filter-included-fields="profit_filterOn"
                  />
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="profit_currentPage"
                          :total-rows="profit_count"
                          :per-page="profit_perPage"
                          first-number
                          last-number
                        />
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
              <!-- <b-tab title="Buy" disabled> </b-tab>
                        <b-tab title="Sell" disabled> </b-tab> -->
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>